document.addEventListener('DOMContentLoaded', function () {
  var section = document.querySelector('.cn');
  var video = section && section.querySelector('.cn-video');
  var btn = section && section.querySelector('[data-cn-sound]');
  if (!section || !video || !btn) return;

  function refresh() {
    var on = !video.muted;
    section.setAttribute('data-sound-on', on ? 'true' : 'false');
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
  }

  btn.addEventListener('click', function () {
    video.muted = !video.muted;
    if (!video.muted && video.paused) {
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }
    refresh();
  });

  try { video.play().catch(function () {}); } catch (e) {}
  refresh();
});
